import { render, staticRenderFns } from "./RegisterByGoogle.vue?vue&type=template&id=0b471113&scoped=true"
import script from "./RegisterByGoogle.vue?vue&type=script&lang=js"
export * from "./RegisterByGoogle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b471113",
  null
  
)

export default component.exports